import { createFileRoute } from '@tanstack/react-router';

import { ProjectDetailsPage } from '@/features/projects/ProjectDetailsPage';

function ProjectDetailsRoute() {
  const { projectId } = Route.useParams();
  return <ProjectDetailsPage projectId={projectId} />;
}

export const Route = createFileRoute('/admin/_app/projects/$projectId')({
  component: ProjectDetailsRoute,
});
